<template>
  <v-row>
    <v-col cols="12">
      <v-data-table
        :headers="headers"
        :items="events"
        item-key="id"
        class="elevation-1"
        dense
        hide-default-footer
        disable-pagination
        disable-sort
      >
        <template v-slot:[`item.dateAction`]="{ item }">
          {{ formatDate(item.dateAction) }}
        </template>
        <template v-slot:[`item.etat`]="{ item }">
          {{ item.etat.libelle }}
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import ApiEventRepository from "@/repositories/ApiEventRepository";
import moment from "moment";
import { EtatDemande } from "@/mixins/EtatDemande.js";
import { mapState } from "vuex";

export default {
  name: "HistoriqueCandidature",
  props: {
    idCandidature: { type: Number, required: true }
  },
  mixins: [EtatDemande],
  data() {
    return {
      events: []
    };
  },
  computed: {
    ...mapState(["user"]),
    headers() {
      return this.user.roles.indexOf("ROLE_ETUDIANT") > -1
        ? [
            {
              text: "Action",
              align: "left",
              value: "action"
            },
            {
              text: "Date",
              align: "left",
              value: "dateAction"
            },
            {
              text: "Par",
              align: "left",
              value: "roleActeur"
            },
            {
              text: "État",
              align: "left",
              value: "etat"
            },
            {
              text: "Motif",
              align: "left",
              value: "motif"
            }
          ]
        : [
            {
              text: "Action",
              align: "left",
              value: "action"
            },
            {
              text: "Date",
              align: "left",
              value: "dateAction"
            },
            {
              text: "Par",
              align: "left",
              value: "acteur"
            },
            {
              text: "rôle",
              align: "left",
              value: "roleActeur"
            },
            {
              text: "État",
              align: "left",
              value: "etat"
            },
            {
              text: "Motif",
              align: "left",
              value: "motif"
            }
          ];
    }
  },
  async created() {
    if (this.idCandidature) {
      await this.getEventsCandidature(this.idCandidature);
    }
  },
  methods: {
    formatDate(date) {
      return date ? moment(date).format("DD/MM/YYYY HH:mm") : "";
    },
    async getEventsCandidature(idCandidature) {
      try {
        const events = await ApiEventRepository.getEventsCandidature(
          idCandidature
        );
        this.events = events;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    }
  }
};
</script>
